// Jediný zdroj pravdy pro fáze tranzice („Moje cesta" i Průvodce).
// Dřív byla tahle konstanta zkopírovaná v ProfileJourney.js a JourneyPage.js.
// Id musí odpovídat id v backendové kolekci journey_stages.
// `label` a `desc` jsou české a zůstávají: `label` se posílá na server jako
// uložený popisek fáze. Pro zobrazení se používá `klic` / `klicPopis`.
export const STAGES = [
  { id: 'thinking', label: 'Uvažuji o tranzici', color: '#E8E8E8', desc: 'Přemýšlím, kdo jsem a jaká cesta je ta moje.', klic: 'faze.thinking', klicPopis: 'faze.thinking.popis' },
  { id: 'research', label: 'Hledám informace', color: '#C3AED6', desc: 'Čtu, ptám se, hledám zdroje a komunitu.', klic: 'faze.research', klicPopis: 'faze.research.popis' },
  { id: 'therapist', label: 'První návštěva terapeuta', color: '#A8D8EA', desc: 'Mluvím s odborníkem o své cestě.', klic: 'faze.therapist', klicPopis: 'faze.therapist.popis' },
  { id: 'hormones', label: 'Hormonální léčba', color: '#5BCEFA', desc: 'Začínám nebo pokračuji v hormonální terapii.', klic: 'faze.hormones', klicPopis: 'faze.hormones.popis' },
  { id: 'documents', label: 'Změna dokladů', color: '#8A7CFF', desc: 'Pracuji na úřední změně jména nebo pohlaví.', klic: 'faze.documents', klicPopis: 'faze.documents.popis' },
  { id: 'cosmetic', label: 'Kosmetické úpravy', color: '#F5A9B8', desc: 'Pracuji na svém vzhledu – vlasy, make-up, styl.', klic: 'faze.cosmetic', klicPopis: 'faze.cosmetic.popis' },
  { id: 'surgery-thinking', label: 'Zvažuji operace', color: '#F7C59F', desc: 'Přemýšlím o chirurgických možnostech.', klic: 'faze.surgery-thinking', klicPopis: 'faze.surgery-thinking.popis' },
  { id: 'surgery', label: 'Po operacích', color: '#A8E6CF', desc: 'Jsem po jedné nebo více operacích.', klic: 'faze.surgery', klicPopis: 'faze.surgery.popis' },
  { id: 'stable', label: 'Stabilní fáze', color: '#B5C99A', desc: 'Jsem na místě, kde chci být, a žiji svůj život.', klic: 'faze.stable', klicPopis: 'faze.stable.popis' },
  { id: 'individual', label: 'Individuální cesta', color: '#FFD1DC', desc: 'Moje cesta neodpovídá žádné škatulce – a to je OK.', klic: 'faze.individual', klicPopis: 'faze.individual.popis' },
];

/** Fáze podle id, nebo null. */
export function stageById(id) {
  return STAGES.find(s => s.id === id) || null;
}

/** Barva fáze; pro neznámé id vrací výchozí fialovou aplikace. */
export function stageColor(id) {
  return stageById(id)?.color || '#8A7CFF';
}

/**
 * Název fáze pro zobrazení.
 *
 * Fáze chodí i ze serveru (a tam mají jen český `name`). Když id odpovídá
 * některé ze známých fází, použije se překlad; u neznámé zůstane to, co
 * poslal server.
 */
export function nazevFaze(t, id, nahrada) {
  const faze = stageById(id);
  return faze ? t(faze.klic) : (nahrada || id);
}
